import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faBold,
  faItalic,
  faLink,
  faList,
  faStrikethrough,
  faUnderline,
} from "@fortawesome/pro-regular-svg-icons";
import { Select } from "components/select/index";
import Input from "components/form/input/Input";
import { WebsiteBuilderPopupRow } from "../../../../helpers/popup/WebsiteBuilderPopupRow";
import { WebsiteBuilderPopupSections } from "../../../../helpers/popup/WebsiteBuilderPopupSections";

export function ParagraphSettings() {
  const { Option } = Select;
  const { t } = useTranslation();

  function renderStyleSection() {
    return (
      <div className="website-builder-paragraph-settings-text-options">
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faBold} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faItalic} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faUnderline} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faStrikethrough} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faLink} />
      </div>
    );
  }

  function renderFontSection() {
    return (
      <>
        <Select
          label={t("Font")}
          onChange={() => {}}
          defaultValue={""}
        >
          <Option value="Inter">Inter</Option>
        </Select>
        <WebsiteBuilderPopupRow>
          <Select
            label={t("Weight")}
            onChange={() => {}}
            defaultValue={""}
          >
            <Option value={500}>Semibold</Option>
          </Select>
          <Input
            label={t("Size (px)")}
            value={""}
            onChange={() => {}}
          />
        </WebsiteBuilderPopupRow>
      </>
    );
  }

  function renderOrientationSection() {
    return (
      <div className="website-builder-paragraph-settings-text-options">
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faAlignLeft} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faAlignCenter} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faAlignRight} />
        <FontAwesomeIcon className="paragraph-settings-text-option" icon={faList} />
      </div>
    );
  }

  return (
    <WebsiteBuilderPopupSections sections={[renderStyleSection(), renderFontSection(), renderOrientationSection()]} />
  );
}
